import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import {
  E_FACTURA_FILTERS,
  type EFacturaFilterValue,
  EFacturaScreen,
} from '../../../features/efactura/efactura-screen';

const filterValues = E_FACTURA_FILTERS.map((filter) => filter.value) as [
  EFacturaFilterValue,
  ...EFacturaFilterValue[],
];

/**
 * Firma, starea și luna stau în adresă, ca la Facturare: un link trimis cuiva deschide aceeași
 * listă. O valoare stricată cade pe implicit, nu dă eroare.
 */
const searchSchema = z.object({
  firma: z.uuid().optional().catch(undefined),
  stare: z.enum(filterValues).optional().catch(undefined),
  luna: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .optional()
    .catch(undefined),
});

/** „Conta → e-Factura" ([#240](https://github.com/bplugaru/efx-pcrm/issues/240)): toate firmele. */
export const Route = createFileRoute('/_authenticated/conta/efactura')({
  validateSearch: searchSchema,
  component: EFacturaPagina,
});

function EFacturaPagina() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const go = (patch: Partial<z.infer<typeof searchSchema>>) =>
    navigate({ search: (current) => ({ ...current, ...patch }), replace: true });

  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Conta</h1>
      </Header>

      <Main className="flex flex-1 flex-col gap-4 sm:gap-6">
        <EFacturaScreen
          companyId={search.firma}
          filter={search.stare}
          month={search.luna}
          onCompanyChange={(firma) => go({ firma })}
          onFilterChange={(stare) => go({ stare })}
          onMonthChange={(luna) => go({ luna })}
        />
      </Main>
    </>
  );
}
